"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.WarningType = exports.VonageSourceType = exports.PipelineInfoData = exports.MediaProcessorConnector = exports.MediaProcessor = exports.ErrorFunction = void 0;
exports.getVonageMetadata = x;
exports.isSupported = Ie;
exports.setVonageMetadata = xe;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _globalThis = function (Object) {
  function get() {
    var _global = this || self;
    delete Object.prototype.__magic__;
    return _global;
  }
  if (typeof globalThis === "object") {
    return globalThis;
  }
  if (this) {
    return get();
  } else {
    Object.defineProperty(Object.prototype, "__magic__", {
      configurable: true,
      get: get
    });
    var _global = __magic__;
    return _global;
  }
}(Object);
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function Ie() {
  return new Promise((t, e) => {
    typeof MediaStreamTrackProcessor > "u" || typeof MediaStreamTrackGenerator > "u" ? e("Your browser does not support the MediaStreamTrack API for Insertable Streams of Media.") : t();
  });
}
let l = function l() {};
l.updates = {
  transformer_new: "New transformer",
  transformer_null: "Null transformer"
};
l.errors = {
  transformer_none: "No transformers provided",
  transformer_start: "Cannot start transformer",
  transformer_transform: "Cannot transform frame",
  transformer_flush: "Cannot flush transformer",
  readable_null: "Readable is null",
  writable_null: "Writable is null"
};
function j(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
const f = /* @__PURE__ */new WeakMap(),
  T = /* @__PURE__ */new WeakMap(),
  g = /* @__PURE__ */new WeakMap(),
  C = Symbol("anyProducer"),
  U = Promise.resolve(),
  S = Symbol("listenerAdded"),
  R = Symbol("listenerRemoved");
let A = !1;
function p(t) {
  if (typeof t != "string" && typeof t != "symbol") throw new TypeError("eventName must be a string or a symbol");
}
function b(t) {
  if (typeof t != "function") throw new TypeError("listener must be a function");
}
function m(t, e) {
  const r = T.get(t);
  return r.has(e) || r.set(e, /* @__PURE__ */new Set()), r.get(e);
}
function _(t, e) {
  const r = typeof e == "string" || typeof e == "symbol" ? e : C,
    s = g.get(t);
  return s.has(r) || s.set(r, /* @__PURE__ */new Set()), s.get(r);
}
function B(t, e, r) {
  const s = g.get(t);
  if (s.has(e)) {
    for (var _iterator = _createForOfIteratorHelperLoose(s.get(e)), _step; !(_step = _iterator()).done;) {
      const i = _step.value;
      i.enqueue(r);
    }
  }
  if (s.has(C)) {
    const i = Promise.all([e, r]);
    for (var _iterator2 = _createForOfIteratorHelperLoose(s.get(C)), _step2; !(_step2 = _iterator2()).done;) {
      const n = _step2.value;
      n.enqueue(i);
    }
  }
}
function D(t, e) {
  e = Array.isArray(e) ? e : [e];
  let r = !1,
    s = () => {},
    i = [];
  const n = {
    enqueue(o) {
      i.push(o), s();
    },
    finish() {
      r = !0, s();
    }
  };
  for (var _iterator3 = _createForOfIteratorHelperLoose(e), _step3; !(_step3 = _iterator3()).done;) {
    const o = _step3.value;
    _(t, o).add(n);
  }
  return {
    next() {
      var _this = this;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!i) {
                _context.next = 20;
                break;
              }
              if (!(i.length === 0)) {
                _context.next = 12;
                break;
              }
              if (!r) {
                _context.next = 6;
                break;
              }
              _context.t2 = (i = void 0, _this.next());
              _context.next = 9;
              break;
            case 6:
              _context.next = 8;
              return new Promise(o => {
                s = o;
              });
            case 8:
              _context.t2 = _this.next();
            case 9:
              _context.t1 = _context.t2;
              _context.next = 17;
              break;
            case 12:
              _context.t3 = !1;
              _context.next = 15;
              return i.shift();
            case 15:
              _context.t4 = _context.sent;
              _context.t1 = {
                done: _context.t3,
                value: _context.t4
              };
            case 17:
              _context.t0 = _context.t1;
              _context.next = 21;
              break;
            case 20:
              _context.t0 = {
                done: !0
              };
            case 21:
              return _context.abrupt("return", _context.t0);
            case 22:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    return(o) {
      var _arguments = arguments;
      return (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var _iterator4, _step4, a;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              i = void 0;
              for (_iterator4 = _createForOfIteratorHelperLoose(e); !(_step4 = _iterator4()).done;) {
                a = _step4.value;
                _(t, a).delete(n);
              }
              s();
              if (!(_arguments.length > 0)) {
                _context2.next = 11;
                break;
              }
              _context2.t1 = !0;
              _context2.next = 7;
              return o;
            case 7:
              _context2.t2 = _context2.sent;
              _context2.t0 = {
                done: _context2.t1,
                value: _context2.t2
              };
              _context2.next = 12;
              break;
            case 11:
              _context2.t0 = {
                done: !0
              };
            case 12:
              return _context2.abrupt("return", _context2.t0);
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    [Symbol.asyncIterator]() {
      return this;
    }
  };
}
function $(t) {
  if (t === void 0) return G;
  if (!Array.isArray(t)) throw new TypeError("`methodNames` must be an array of strings");
  for (var _iterator5 = _createForOfIteratorHelperLoose(t), _step5; !(_step5 = _iterator5()).done;) {
    const e = _step5.value;
    if (!G.includes(e)) throw typeof e != "string" ? new TypeError("`methodNames` element must be a string") : new Error(`${e} is not Emittery method`);
  }
  return t;
}
const M = t => t === S || t === R;
let d = /*#__PURE__*/function () {
  d.mixin = function mixin(e, r) {
    return r = $(r), s => {
      if (typeof s != "function") throw new TypeError("`target` must be function");
      for (var _iterator6 = _createForOfIteratorHelperLoose(r), _step6; !(_step6 = _iterator6()).done;) {
        const o = _step6.value;
        if (s.prototype[o] !== void 0) throw new Error(`The property \`${o}\` already exists on \`target\``);
      }
      function i() {
        return Object.defineProperty(this, e, {
          enumerable: !1,
          value: new d()
        }), this[e];
      }
      Object.defineProperty(s.prototype, e, {
        enumerable: !1,
        get: i
      });
      const n = o => function () {
        return this[e][o](...arguments);
      };
      for (var _iterator7 = _createForOfIteratorHelperLoose(r), _step7; !(_step7 = _iterator7()).done;) {
        const o = _step7.value;
        Object.defineProperty(s.prototype, o, {
          enumerable: !1,
          value: n(o)
        });
      }
      return s;
    };
  };
  function d(e) {
    if (e === void 0) {
      e = {};
    }
    f.set(this, /* @__PURE__ */new Set()), T.set(this, /* @__PURE__ */new Map()), g.set(this, /* @__PURE__ */new Map()), this.debug = e.debug || {}, this.debug.enabled === void 0 && (this.debug.enabled = !1), this.debug.logger || (this.debug.logger = (r, s, i, n) => {
      try {
        n = JSON.stringify(n);
      } catch (_unused) {
        n = `Object with the following keys failed to stringify: ${Object.keys(n).join(",")}`;
      }
      typeof i == "symbol" && (i = i.toString());
      const o = /* @__PURE__ */new Date(),
        a = `${o.getHours()}:${o.getMinutes()}:${o.getSeconds()}.${o.getMilliseconds()}`;
      console.log(`[${a}][emittery:${r}][${s}] Event Name: ${i}
	data: ${n}`);
    });
  }
  var _proto = d.prototype;
  _proto.logIfDebugEnabled = function logIfDebugEnabled(e, r, s) {
    (d.isDebugEnabled || this.debug.enabled) && this.debug.logger(e, this.debug.name, r, s);
  };
  _proto.on = function on(e, r) {
    b(r), e = Array.isArray(e) ? e : [e];
    for (var _iterator8 = _createForOfIteratorHelperLoose(e), _step8; !(_step8 = _iterator8()).done;) {
      const s = _step8.value;
      p(s), m(this, s).add(r), this.logIfDebugEnabled("subscribe", s, void 0), M(s) || this.emit(S, {
        eventName: s,
        listener: r
      });
    }
    return this.off.bind(this, e, r);
  };
  _proto.off = function off(e, r) {
    b(r), e = Array.isArray(e) ? e : [e];
    for (var _iterator9 = _createForOfIteratorHelperLoose(e), _step9; !(_step9 = _iterator9()).done;) {
      const s = _step9.value;
      p(s), m(this, s).delete(r), this.logIfDebugEnabled("unsubscribe", s, void 0), M(s) || this.emit(R, {
        eventName: s,
        listener: r
      });
    }
  };
  _proto.once = function once(e) {
    return new Promise(r => {
      const s = this.on(e, i => {
        s(), r(i);
      });
    });
  };
  _proto.events = function events(e) {
    e = Array.isArray(e) ? e : [e];
    for (var _iterator10 = _createForOfIteratorHelperLoose(e), _step10; !(_step10 = _iterator10()).done;) {
      const r = _step10.value;
      p(r);
    }
    return D(this, e);
  };
  _proto.emit = /*#__PURE__*/function () {
    var _emit = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(e, r) {
      var s, i, n, o;
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            p(e), this.logIfDebugEnabled("emit", e, r), B(this, e, r);
            s = m(this, e), i = f.get(this), n = [...s], o = M(e) ? [] : [...i];
            _context5.next = 4;
            return U;
          case 4:
            _context5.next = 6;
            return Promise.all([...n.map( /*#__PURE__*/function () {
              var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(a) {
                return _regenerator.default.wrap(function _callee3$(_context3) {
                  while (1) switch (_context3.prev = _context3.next) {
                    case 0:
                      if (!s.has(a)) {
                        _context3.next = 2;
                        break;
                      }
                      return _context3.abrupt("return", a(r));
                    case 2:
                    case "end":
                      return _context3.stop();
                  }
                }, _callee3);
              }));
              return function (_x3) {
                return _ref.apply(this, arguments);
              };
            }()), ...o.map( /*#__PURE__*/function () {
              var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(a) {
                return _regenerator.default.wrap(function _callee4$(_context4) {
                  while (1) switch (_context4.prev = _context4.next) {
                    case 0:
                      if (!i.has(a)) {
                        _context4.next = 2;
                        break;
                      }
                      return _context4.abrupt("return", a(e, r));
                    case 2:
                    case "end":
                      return _context4.stop();
                  }
                }, _callee4);
              }));
              return function (_x4) {
                return _ref2.apply(this, arguments);
              };
            }())]);
          case 6:
          case "end":
            return _context5.stop();
        }
      }, _callee5, this);
    }));
    function emit(_x, _x2) {
      return _emit.apply(this, arguments);
    }
    return emit;
  }();
  _proto.emitSerial = /*#__PURE__*/function () {
    var _emitSerial = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(e, r) {
      var s, i, n, o, _i, _n, a, _i2, _o;
      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            p(e), this.logIfDebugEnabled("emitSerial", e, r);
            s = m(this, e), i = f.get(this), n = [...s], o = [...i];
            _context6.next = 4;
            return U;
          case 4:
            _i = 0, _n = n;
          case 5:
            if (!(_i < _n.length)) {
              _context6.next = 14;
              break;
            }
            a = _n[_i];
            _context6.t0 = s.has(a);
            if (!_context6.t0) {
              _context6.next = 11;
              break;
            }
            _context6.next = 11;
            return a(r);
          case 11:
            _i++;
            _context6.next = 5;
            break;
          case 14:
            _i2 = 0, _o = o;
          case 15:
            if (!(_i2 < _o.length)) {
              _context6.next = 24;
              break;
            }
            a = _o[_i2];
            _context6.t1 = i.has(a);
            if (!_context6.t1) {
              _context6.next = 21;
              break;
            }
            _context6.next = 21;
            return a(e, r);
          case 21:
            _i2++;
            _context6.next = 15;
            break;
          case 24:
          case "end":
            return _context6.stop();
        }
      }, _callee6, this);
    }));
    function emitSerial(_x5, _x6) {
      return _emitSerial.apply(this, arguments);
    }
    return emitSerial;
  }();
  _proto.onAny = function onAny(e) {
    return b(e), this.logIfDebugEnabled("subscribeAny", void 0, void 0), f.get(this).add(e), this.emit(S, {
      listener: e
    }), this.offAny.bind(this, e);
  };
  _proto.anyEvent = function anyEvent() {
    return D(this);
  };
  _proto.offAny = function offAny(e) {
    b(e), this.logIfDebugEnabled("unsubscribeAny", void 0, void 0), this.emit(R, {
      listener: e
    }), f.get(this).delete(e);
  };
  _proto.clearListeners = function clearListeners(e) {
    e = Array.isArray(e) ? e : [e];
    for (var _iterator11 = _createForOfIteratorHelperLoose(e), _step11; !(_step11 = _iterator11()).done;) {
      const r = _step11.value;
      if (this.logIfDebugEnabled("clear", r, void 0), typeof r == "string" || typeof r == "symbol") {
        m(this, r).clear();
        const s = _(this, r);
        for (var _iterator12 = _createForOfIteratorHelperLoose(s), _step12; !(_step12 = _iterator12()).done;) {
          const i = _step12.value;
          i.finish();
        }
        s.clear();
      } else {
        f.get(this).clear();
        for (var _iterator13 = _createForOfIteratorHelperLoose(T.get(this).values()), _step13; !(_step13 = _iterator13()).done;) {
          const s = _step13.value;
          s.clear();
        }
        for (var _iterator14 = _createForOfIteratorHelperLoose(g.get(this).values()), _step14; !(_step14 = _iterator14()).done;) {
          const s = _step14.value;
          for (var _iterator15 = _createForOfIteratorHelperLoose(s), _step15; !(_step15 = _iterator15()).done;) {
            const i = _step15.value;
            i.finish();
          }
          s.clear();
        }
      }
    }
  };
  _proto.listenerCount = function listenerCount(e) {
    e = Array.isArray(e) ? e : [e];
    let r = 0;
    for (var _iterator16 = _createForOfIteratorHelperLoose(e), _step16; !(_step16 = _iterator16()).done;) {
      const s = _step16.value;
      if (typeof s == "string") {
        r += f.get(this).size + m(this, s).size + _(this, s).size + _(this).size;
        continue;
      }
      typeof s < "u" && p(s), r += f.get(this).size;
      for (var _iterator17 = _createForOfIteratorHelperLoose(T.get(this).values()), _step17; !(_step17 = _iterator17()).done;) {
        const i = _step17.value;
        r += i.size;
      }
      for (var _iterator18 = _createForOfIteratorHelperLoose(g.get(this).values()), _step18; !(_step18 = _iterator18()).done;) {
        const i = _step18.value;
        r += i.size;
      }
    }
    return r;
  };
  _proto.bindMethods = function bindMethods(e, r) {
    if (typeof e != "object" || e === null) throw new TypeError("`target` must be an object");
    r = $(r);
    for (var _iterator19 = _createForOfIteratorHelperLoose(r), _step19; !(_step19 = _iterator19()).done;) {
      const s = _step19.value;
      if (e[s] !== void 0) throw new Error(`The property \`${s}\` already exists on \`target\``);
      Object.defineProperty(e, s, {
        enumerable: !1,
        value: this[s].bind(this)
      });
    }
  };
  (0, _createClass2.default)(d, null, [{
    key: "isDebugEnabled",
    get: function get() {
      if (typeof process != "object") return A;
      const _ref3 = process || {
          env: {}
        },
        e = _ref3.env;
      return e.DEBUG === "emittery" || e.DEBUG === "*" || A;
    },
    set: function set(e) {
      A = e;
    }
  }]);
  return d;
}();
const G = Object.getOwnPropertyNames(d.prototype).filter(t => t !== "constructor");
Object.defineProperty(d, "listenerAdded", {
  value: S,
  writable: !1,
  enumerable: !0,
  configurable: !1
});
Object.defineProperty(d, "listenerRemoved", {
  value: R,
  writable: !1,
  enumerable: !0,
  configurable: !1
});
var Y = d;
const v = /* @__PURE__ */j(Y);
function q(t) {
  return typeof t == "object" && t !== null && "message" in t && typeof t.message == "string";
}
function J(t) {
  if (q(t)) return t;
  try {
    return new Error(JSON.stringify(t));
  } catch (_unused2) {
    return new Error(String(t));
  }
}
function I(t) {
  return J(t).message;
}
var K = Object.defineProperty,
  X = (t, e, r) => e in t ? K(t, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : t[e] = r,
  Z = (t, e, r) => (X(t, typeof e != "symbol" ? e + "" : e, r), r),
  N = /* @__PURE__ */(t => (t.automation = "automation", t.test = "test", t.vbc = "vbc", t.video = "video", t.voice = "voice", t))(N || {});
exports.VonageSourceType = N;
const ee = "hlg.tokbox.com/prod/logging/vcp_webrtc",
  re = "https://",
  te = 1e4;
let w;
const se = new Uint8Array(16);
function ie() {
  if (!w && (w = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !w)) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return w(se);
}
const c = [];
for (let t = 0; t < 256; ++t) c.push((t + 256).toString(16).slice(1));
function ne(t, e) {
  if (e === void 0) {
    e = 0;
  }
  return (c[t[e + 0]] + c[t[e + 1]] + c[t[e + 2]] + c[t[e + 3]] + "-" + c[t[e + 4]] + c[t[e + 5]] + "-" + c[t[e + 6]] + c[t[e + 7]] + "-" + c[t[e + 8]] + c[t[e + 9]] + "-" + c[t[e + 10]] + c[t[e + 11]] + c[t[e + 12]] + c[t[e + 13]] + c[t[e + 14]] + c[t[e + 15]]).toLowerCase();
}
const oe = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto),
  H = {
    randomUUID: oe
  };
function ae(t, e, r) {
  if (H.randomUUID && !e && !t) return H.randomUUID();
  t = t || {};
  const s = t.random || (t.rng || ie)();
  if (s[6] = s[6] & 15 | 64, s[8] = s[8] & 63 | 128, e) {
    r = r || 0;
    for (let i = 0; i < 16; ++i) e[r + i] = s[i];
    return e;
  }
  return ne(s);
}
function F(t, e) {
  _globalThis.vonage || (_globalThis.vonage = {}), _globalThis.vonage.workerizer || (_globalThis.vonage.workerizer = {});
  let r = _globalThis.vonage.workerizer;
  return r[t] || (r[t] = e), r[t];
}
const h = F("globals", {});
var u = /* @__PURE__ */(t => (t.INIT = "INIT", t.FORWARD = "FORWARD", t.TERMINATE = "TERMINATE", t.GLOBALS_SYNC = "GLOBALS_SYNC", t))(u || {});
function z(t) {
  return [ImageBitmap, ReadableStream, WritableStream].some(r => t instanceof r);
}
let ce = 0;
function le(t, e, r, s, i) {
  const n = ce++;
  return t.postMessage({
    id: n,
    type: e,
    functionName: r,
    args: s
  }, s.filter(a => z(a))), new Promise(a => {
    i == null || i.set(n, a);
  });
}
function y(t, e) {
  const r = t.id,
    s = t.type,
    i = Array.isArray(e) ? e : [e];
  postMessage({
    id: r,
    type: s,
    result: e
  }, i.filter(n => z(n)));
}
const Q = F("workerized", {});
function V() {
  return typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope;
}
function fe() {
  return _fe.apply(this, arguments);
}
function _fe() {
  _fe = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee21() {
    var t, e, _Q$e$workerContext, r, s;
    return _regenerator.default.wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          if (!V()) {
            _context21.next = 4;
            break;
          }
          y({
            type: u.GLOBALS_SYNC
          }, h);
          _context21.next = 8;
          break;
        case 4:
          t = [];
          for (e in Q) {
            _Q$e$workerContext = Q[e].workerContext, r = _Q$e$workerContext.worker, s = _Q$e$workerContext.resolvers;
            r && t.push(le(r, u.GLOBALS_SYNC, "", [h], s));
          }
          _context21.next = 8;
          return Promise.all(t);
        case 8:
        case "end":
          return _context21.stop();
      }
    }, _callee21);
  }));
  return _fe.apply(this, arguments);
}
function P(t, e) {
  if (Array.isArray(e)) e.splice(0, e.length);else if (typeof e == "object") for (const r in e) delete e[r];
  for (const r in t) Array.isArray(t[r]) ? (e[r] = [], P(t[r], e[r])) : typeof t[r] == "object" ? (e[r] = {}, P(t[r], e[r])) : e[r] = t[r];
}
function he(_x7, _x8) {
  return _he.apply(this, arguments);
}
function _he() {
  _he = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee22(t, e) {
    var r, s;
    return _regenerator.default.wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          r = t.functionName, s = t.args;
          if (e.instance) {
            _context22.next = 3;
            break;
          }
          throw "instance not initialized";
        case 3:
          if (r) {
            _context22.next = 5;
            break;
          }
          throw "missing function name to call";
        case 5:
          if (e.instance[r]) {
            _context22.next = 7;
            break;
          }
          throw `undefined function [${r}] in class ${e.instance.constructor.workerId}`;
        case 7:
          _context22.t0 = y;
          _context22.t1 = t;
          _context22.next = 11;
          return e.instance[r](...(s != null ? s : []));
        case 11:
          _context22.t2 = _context22.sent;
          (0, _context22.t0)(_context22.t1, _context22.t2);
        case 13:
        case "end":
          return _context22.stop();
      }
    }, _callee22);
  }));
  return _he.apply(this, arguments);
}
const ue = F("registeredWorkers", {});
function de(t, e) {
  if (!t.args) throw "Missing className while initializing worker";
  const _t$args = t.args,
    r = _t$args[0],
    s = _t$args[1],
    i = ue[r];
  if (i) e.instance = new i(t.args.slice(1));else throw `unknown worker class ${r}`;
  P(s, h), y(t, typeof e.instance !== void 0);
}
function pe(_x9, _x10) {
  return _pe.apply(this, arguments);
}
function _pe() {
  _pe = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee23(t, e) {
    var r, s;
    return _regenerator.default.wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          r = t.args;
          if (e.instance) {
            _context23.next = 3;
            break;
          }
          throw "instance not initialized";
        case 3:
          _context23.t0 = e.instance.terminate;
          if (!_context23.t0) {
            _context23.next = 8;
            break;
          }
          _context23.next = 7;
          return e.instance.terminate(...(r != null ? r : []));
        case 7:
          s = _context23.sent;
        case 8:
          y(t, s);
        case 9:
        case "end":
          return _context23.stop();
      }
    }, _callee23);
  }));
  return _pe.apply(this, arguments);
}
function me(t) {
  if (!t.args) throw "Missing globals while syncing";
  P(t.args[0], h), y(t, {});
}
function ge() {
  const t = {};
  onmessage = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(e) {
      var r;
      return _regenerator.default.wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            r = e.data;
            _context7.t0 = r.type;
            _context7.next = _context7.t0 === u.INIT ? 4 : _context7.t0 === u.FORWARD ? 6 : _context7.t0 === u.TERMINATE ? 8 : _context7.t0 === u.GLOBALS_SYNC ? 10 : 12;
            break;
          case 4:
            de(r, t);
            return _context7.abrupt("break", 12);
          case 6:
            he(r, t);
            return _context7.abrupt("break", 12);
          case 8:
            pe(r, t);
            return _context7.abrupt("break", 12);
          case 10:
            me(r);
            return _context7.abrupt("break", 12);
          case 12:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function onmessage(_x11) {
      return _ref4.apply(this, arguments);
    };
  }();
}
V() && ge();
function _e(t, e) {
  return h[t] || (h[t] = e), [() => h[t], /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(r) {
      return _regenerator.default.wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            h[t] = r;
            _context8.next = 3;
            return fe();
          case 3:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function (_x12) {
      return _ref5.apply(this, arguments);
    };
  }()];
}
function ye(t, e) {
  return _e(t, e);
}
const _ye = ye("metadata"),
  be = _ye[0],
  we = _ye[1];
function xe(t) {
  we(t);
}
function x() {
  return be();
}
let L = /*#__PURE__*/function () {
  function L(e, r) {
    Z(this, "uuid"), this.config = e, this.uuid = r != null ? r : ae();
  }
  var _proto2 = L.prototype;
  _proto2.send = /*#__PURE__*/function () {
    var _send = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9(e) {
      var r, s, i, _ref6, n, o, a, k;
      return _regenerator.default.wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            _ref6 = (r = x()) != null ? r : {}, n = _ref6.appId, o = _ref6.sourceType;
            if (!(!n || !o)) {
              _context9.next = 3;
              break;
            }
            return _context9.abrupt("return", "metadata missing");
          case 3:
            a = new AbortController(), k = setTimeout(() => a.abort(), te);
            _context9.next = 6;
            return ((i = (s = this.config) == null ? void 0 : s.fetch) != null ? i : fetch)(this.getUrl(), {
              method: "POST",
              headers: this.getHeaders(),
              body: JSON.stringify(this.buildReport(e)),
              signal: a.signal
            });
          case 6:
            clearTimeout(k);
            return _context9.abrupt("return", "success");
          case 8:
          case "end":
            return _context9.stop();
        }
      }, _callee9, this);
    }));
    function send(_x13) {
      return _send.apply(this, arguments);
    }
    return send;
  }();
  _proto2.getUrl = function getUrl() {
    var e;
    let r = (e = x().proxyUrl) != null ? e : re;
    return r += (r.at(-1) === "/" ? "" : "/") + ee, r;
  };
  _proto2.getHeaders = function getHeaders() {
    return {
      "Content-Type": "application/json"
    };
  };
  _proto2.buildReport = function buildReport(e) {
    const r = x();
    return Object.assign({
      guid: this.uuid
    }, e, {
      applicationId: r.appId,
      timestamp: Date.now(),
      proxyUrl: r.proxyUrl,
      source: r.sourceType
    });
  };
  return L;
}();
const E = "2.0.4";
let Te = /*#__PURE__*/function () {
  function Te(e, r) {
    this.config = e, this.frameTransformedCount = 0, this.frameFromSourceCount = 0, this.startAt = 0, this.reporter = new L(e, r);
  }
  var _proto3 = Te.prototype;
  _proto3.onFrameFromSource = /*#__PURE__*/function () {
    var _onFrameFromSource = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10() {
      return _regenerator.default.wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            this.frameFromSourceCount++;
          case 1:
          case "end":
            return _context10.stop();
        }
      }, _callee10, this);
    }));
    function onFrameFromSource() {
      return _onFrameFromSource.apply(this, arguments);
    }
    return onFrameFromSource;
  }();
  _proto3.onFrameTransformed = /*#__PURE__*/function () {
    var _onFrameTransformed = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11(e, r) {
      var s, i, n, o, a, k, W;
      return _regenerator.default.wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            if (e === void 0) {
              e = {};
            }
            if (r === void 0) {
              r = !1;
            }
            this.startAt === 0 && (this.startAt = Date.now()), this.frameTransformedCount++;
            s = this.startAt, i = this.frameTransformedCount, n = this.frameFromSourceCount, o = Date.now(), a = (o - s) / 1e3, k = i / a, W = n / a;
            return _context11.abrupt("return", r || this.frameTransformedCount >= this.config.loggingIntervalFrameCount ? (this.frameFromSourceCount = 0, this.frameTransformedCount = 0, this.startAt = o, this.reporter.config = this.config, this.reporter.send(Object.assign({}, this.config.report, {
              variation: "QoS",
              fps: W,
              transformedFps: k,
              framesTransformed: i
            }, e))) : "success");
          case 5:
          case "end":
            return _context11.stop();
        }
      }, _callee11, this);
    }));
    function onFrameTransformed(_x14, _x15) {
      return _onFrameTransformed.apply(this, arguments);
    }
    return onFrameTransformed;
  }();
  (0, _createClass2.default)(Te, [{
    key: "fps",
    get: function get() {
      const e = this.startAt,
        r = this.frameFromSourceCount,
        i = (Date.now() - e) / 1e3;
      return r / i;
    }
  }]);
  return Te;
}();
var Ee = /* @__PURE__ */(t => (t.FPS_DROP = "fps_drop", t))(Ee || {}),
  Se = /* @__PURE__ */(t => (t.start = "start", t.transform = "transform", t.flush = "flush", t))(Se || {}),
  O = /* @__PURE__ */(t => (t.pipeline_ended = "pipeline_ended", t.pipeline_ended_with_error = "pipeline_ended_with_error", t.pipeline_started = "pipeline_started", t.pipeline_started_with_error = "pipeline_started_with_error", t.pipeline_restarted = "pipeline_restarted", t.pipeline_restarted_with_error = "pipeline_restarted_with_error", t))(O || {});
exports.PipelineInfoData = O;
exports.ErrorFunction = Se;
exports.WarningType = Ee;
const Re = 500,
  Pe = 0.8;
let ke = /*#__PURE__*/function (_v) {
  (0, _inheritsLoose2.default)(ke, _v);
  function ke(e, r) {
    var _this2;
    _this2 = _v.call(this) || this, _this2.reporter_ = new L(), _this2.reporterQos_ = new Te({
      loggingIntervalFrameCount: Re,
      report: {
        version: E
      }
    }), _this2.index_ = r, _this2.transformer_ = e, _this2.shouldStop_ = !1, _this2.isFlashed_ = !1, _this2.mediaTransformerQosReportStartTimestamp_ = 0, _this2.videoHeight_ = 0, _this2.videoWidth_ = 0, _this2.trackExpectedRate_ = -1, _this2.transformerType_ = "Custom", "getTransformerType" in e && (_this2.transformerType_ = e.getTransformerType()), _this2.report({
      variation: "Create"
    });
    return _this2;
  }
  var _proto4 = ke.prototype;
  _proto4.setTrackExpectedRate = function setTrackExpectedRate(e) {
    this.trackExpectedRate_ = e;
  };
  _proto4.start = /*#__PURE__*/function () {
    var _start = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12(e) {
      var s;
      return _regenerator.default.wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            if (!(this.controller_ = e, this.transformer_ && typeof this.transformer_.start == "function")) {
              _context12.next = 11;
              break;
            }
            _context12.prev = 1;
            _context12.next = 4;
            return this.transformer_.start(e);
          case 4:
            _context12.next = 11;
            break;
          case 6:
            _context12.prev = 6;
            _context12.t0 = _context12["catch"](1);
            this.report({
              message: l.errors.transformer_start,
              variation: "Error",
              error: I(_context12.t0)
            });
            s = {
              eventMetaData: {
                transformerIndex: this.index_
              },
              error: _context12.t0,
              function: "start"
              /* start */
            };

            this.emit("error", s);
          case 11:
          case "end":
            return _context12.stop();
        }
      }, _callee12, this, [[1, 6]]);
    }));
    function start(_x16) {
      return _start.apply(this, arguments);
    }
    return start;
  }();
  _proto4.transform = /*#__PURE__*/function () {
    var _transform = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13(e, r) {
      var _ref7, _ref8;
      var s, i, o, n;
      return _regenerator.default.wrap(function _callee13$(_context13) {
        while (1) switch (_context13.prev = _context13.next) {
          case 0:
            if (!(this.mediaTransformerQosReportStartTimestamp_ === 0 && (this.mediaTransformerQosReportStartTimestamp_ = Date.now()), e instanceof VideoFrame && (this.videoHeight_ = (_ref7 = e == null ? void 0 : e.displayHeight) != null ? _ref7 : 0, this.videoWidth_ = (_ref8 = e == null ? void 0 : e.displayWidth) != null ? _ref8 : 0), this.reporterQos_.onFrameFromSource(), this.transformer_)) {
              _context13.next = 17;
              break;
            }
            if (!this.shouldStop_) {
              _context13.next = 5;
              break;
            }
            console.warn("[Pipeline] flush from transform"), e.close(), this.flush(r), r.terminate();
            _context13.next = 17;
            break;
          case 5:
            _context13.prev = 5;
            _context13.next = 8;
            return (i = (s = this.transformer_).transform) == null ? void 0 : i.call(s, e, r);
          case 8:
            this.reportQos();
            _context13.next = 16;
            break;
          case 11:
            _context13.prev = 11;
            _context13.t0 = _context13["catch"](5);
            this.report({
              message: l.errors.transformer_transform,
              variation: "Error",
              error: I(_context13.t0)
            });
            o = {
              eventMetaData: {
                transformerIndex: this.index_
              },
              error: _context13.t0,
              function: "transform"
              /* transform */
            };

            this.emit("error", o);
          case 16:
            if (this.trackExpectedRate_ != -1 && this.trackExpectedRate_ * Pe > this.reporterQos_.fps) {
              n = {
                eventMetaData: {
                  transformerIndex: this.index_
                },
                warningType: "fps_drop",
                dropInfo: {
                  requested: this.trackExpectedRate_,
                  current: this.reporterQos_.fps
                }
              };
              this.emit("warn", n);
            }
          case 17:
          case "end":
            return _context13.stop();
        }
      }, _callee13, this, [[5, 11]]);
    }));
    function transform(_x17, _x18) {
      return _transform.apply(this, arguments);
    }
    return transform;
  }();
  _proto4.flush = /*#__PURE__*/function () {
    var _flush = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee14(e) {
      var s;
      return _regenerator.default.wrap(function _callee14$(_context14) {
        while (1) switch (_context14.prev = _context14.next) {
          case 0:
            if (!(this.transformer_ && typeof this.transformer_.flush == "function" && !this.isFlashed_)) {
              _context14.next = 12;
              break;
            }
            this.isFlashed_ = !0;
            _context14.prev = 2;
            _context14.next = 5;
            return this.transformer_.flush(e);
          case 5:
            _context14.next = 12;
            break;
          case 7:
            _context14.prev = 7;
            _context14.t0 = _context14["catch"](2);
            this.report({
              message: l.errors.transformer_flush,
              variation: "Error",
              error: I(_context14.t0)
            });
            s = {
              eventMetaData: {
                transformerIndex: this.index_
              },
              error: _context14.t0,
              function: "flush"
              /* flush */
            };

            this.emit("error", s);
          case 12:
            this.reportQos(!0), this.report({
              variation: "Delete"
            });
          case 13:
          case "end":
            return _context14.stop();
        }
      }, _callee14, this, [[2, 7]]);
    }));
    function flush(_x19) {
      return _flush.apply(this, arguments);
    }
    return flush;
  }();
  _proto4.stop = function stop() {
    console.log("[Pipeline] Stop stream."), this.controller_ && (this.flush(this.controller_), this.controller_.terminate()), this.shouldStop_ = !0;
  };
  _proto4.report = function report(e) {
    this.reporter_.send(Object.assign({
      version: E,
      action: "MediaTransformer",
      transformerType: this.transformerType_
    }, e));
  };
  _proto4.reportQos = function reportQos(e) {
    if (e === void 0) {
      e = !1;
    }
    this.reporterQos_.config = Object.assign({}, this.reporterQos_.config), this.reporterQos_.onFrameTransformed({
      version: E,
      action: "MediaTransformer",
      transformerType: this.transformerType_,
      videoWidth: this.videoWidth_,
      videoHeight: this.videoHeight_
    }, e);
  };
  return ke;
}(v);
let Ae = /*#__PURE__*/function (_v2) {
  (0, _inheritsLoose2.default)(Ae, _v2);
  function Ae(e) {
    var _this3;
    _this3 = _v2.call(this) || this, _this3.transformers_ = [], _this3.trackExpectedRate_ = -1;
    for (let r = 0; r < e.length; r++) {
      let s = new ke(e[r], r);
      s.on("error", i => {
        _this3.emit("error", i);
      }), s.on("warn", i => {
        _this3.emit("warn", i);
      }), _this3.transformers_.push(s);
    }
    return _this3;
  }
  var _proto5 = Ae.prototype;
  _proto5.setTrackExpectedRate = function setTrackExpectedRate(e) {
    this.trackExpectedRate_ = e;
    for (var _iterator20 = _createForOfIteratorHelperLoose(this.transformers_), _step20; !(_step20 = _iterator20()).done;) {
      let r = _step20.value;
      r.setTrackExpectedRate(this.trackExpectedRate_);
    }
  };
  _proto5.start = /*#__PURE__*/function () {
    var _start2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee17(e, r) {
      var _this4 = this;
      var s, _iterator21, _step21, i;
      return _regenerator.default.wrap(function _callee17$(_context17) {
        while (1) switch (_context17.prev = _context17.next) {
          case 0:
            if (!(!this.transformers_ || this.transformers_.length === 0)) {
              _context17.next = 3;
              break;
            }
            console.log("[Pipeline] No transformers.");
            return _context17.abrupt("return");
          case 3:
            _context17.prev = 3;
            s = e;
            for (_iterator21 = _createForOfIteratorHelperLoose(this.transformers_); !(_step21 = _iterator21()).done;) {
              i = _step21.value;
              e = e.pipeThrough(new TransformStream(i));
            }
            e.pipeTo(r).then( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee15() {
              return _regenerator.default.wrap(function _callee15$(_context15) {
                while (1) switch (_context15.prev = _context15.next) {
                  case 0:
                    console.log("[Pipeline] Setup.");
                    _context15.next = 3;
                    return r.abort();
                  case 3:
                    _context15.next = 5;
                    return s.cancel();
                  case 5:
                    _this4.emit("pipelineInfo", "pipeline_ended"
                    /* pipeline_ended */);
                  case 6:
                  case "end":
                    return _context15.stop();
                }
              }, _callee15);
            }))).catch( /*#__PURE__*/function () {
              var _ref10 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee16(i) {
                return _regenerator.default.wrap(function _callee16$(_context16) {
                  while (1) switch (_context16.prev = _context16.next) {
                    case 0:
                      e.cancel().then(() => {
                        console.log("[Pipeline] Shutting down streams after abort.");
                      }).catch(n => {
                        console.error("[Pipeline] Error from stream transform:", n);
                      });
                      _context16.next = 3;
                      return r.abort(i);
                    case 3:
                      _context16.next = 5;
                      return s.cancel(i);
                    case 5:
                      _this4.emit("pipelineInfo", "pipeline_ended_with_error"
                      /* pipeline_ended_with_error */);
                    case 6:
                    case "end":
                      return _context16.stop();
                  }
                }, _callee16);
              }));
              return function (_x22) {
                return _ref10.apply(this, arguments);
              };
            }());
            _context17.next = 13;
            break;
          case 9:
            _context17.prev = 9;
            _context17.t0 = _context17["catch"](3);
            this.emit("pipelineInfo", "pipeline_started_with_error"
            /* pipeline_started_with_error */), this.destroy();
            return _context17.abrupt("return");
          case 13:
            this.emit("pipelineInfo", "pipeline_started"
            /* pipeline_started */), console.log("[Pipeline] Pipeline started.");
          case 14:
          case "end":
            return _context17.stop();
        }
      }, _callee17, this, [[3, 9]]);
    }));
    function start(_x20, _x21) {
      return _start2.apply(this, arguments);
    }
    return start;
  }();
  _proto5.destroy = /*#__PURE__*/function () {
    var _destroy = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee18() {
      var _iterator22, _step22, e;
      return _regenerator.default.wrap(function _callee18$(_context18) {
        while (1) switch (_context18.prev = _context18.next) {
          case 0:
            console.log("[Pipeline] Destroying Pipeline.");
            for (_iterator22 = _createForOfIteratorHelperLoose(this.transformers_); !(_step22 = _iterator22()).done;) {
              e = _step22.value;
              e.stop();
            }
          case 2:
          case "end":
            return _context18.stop();
        }
      }, _callee18, this);
    }));
    function destroy() {
      return _destroy.apply(this, arguments);
    }
    return destroy;
  }();
  return Ae;
}(v);
let Ce = /*#__PURE__*/function (_v3) {
  (0, _inheritsLoose2.default)(Ce, _v3);
  function Ce() {
    var _this5;
    _this5 = _v3.call(this) || this, _this5.reporter_ = new L(), _this5.trackExpectedRate_ = -1, _this5.report({
      variation: "Create"
    });
    return _this5;
  }
  /**
   * Sets the expected rate of the track per second.
   * The media processor will use this number for calculating drops in the rate.
   * This could happen when the transformation will take more time than expected.
   * This will not cause an error, just warning to the client.
   * Mostly:
   * Video: 30 frames per second
   * Audio: 50 audio data per second for OPUS
   * In case of increased frame dropping rate a warning will be emitted according to info [here](/docs/intro#errors-and-warnings-listener).
   * ***This is an optional method.***
   * @param trackExpectedRate - number holds the predicted track rate.
   */
  var _proto6 = Ce.prototype;
  _proto6.setTrackExpectedRate = function setTrackExpectedRate(e) {
    this.trackExpectedRate_ = e, this.pipeline_ && this.pipeline_.setTrackExpectedRate(this.trackExpectedRate_);
  }
  /**
   * Starts running the tranformation logic performed by the media processor instance.
   * When running an instance of this class on a Web worker thread the call for this function should be made by the user. See example [here](/docs/intro#webworker-code).
   * When running an instance of this class on the application main thread there is no need to call this method given it will be called by the `MediaProcessorConnector` instance.
   *
   * @param readable Readable stream associated to the media source being processed.
   * @param writable Writable stream associated to the resulting media once processed.
   *
   * @returns
   */;
  _proto6.transform = function transform(e, r) {
    return this.readable_ = e, this.writable_ = r, this.transformInternal();
  }
  /**
   * @private
   */;
  _proto6.transformInternal = function transformInternal() {
    var _this6 = this;
    return new Promise( /*#__PURE__*/function () {
      var _ref11 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee19(e, r) {
        var s;
        return _regenerator.default.wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              if (!(!_this6.transformers_ || _this6.transformers_.length === 0)) {
                _context19.next = 3;
                break;
              }
              _this6.report({
                message: l.errors.transformer_none,
                variation: "Error"
              }), r("[MediaProcessor] Need to set transformers.");
              return _context19.abrupt("return");
            case 3:
              if (_this6.readable_) {
                _context19.next = 6;
                break;
              }
              _this6.report({
                variation: "Error",
                message: l.errors.readable_null
              }), r("[MediaProcessor] Readable is null.");
              return _context19.abrupt("return");
            case 6:
              if (_this6.writable_) {
                _context19.next = 9;
                break;
              }
              _this6.report({
                variation: "Error",
                message: l.errors.writable_null
              }), r("[MediaProcessor] Writable is null.");
              return _context19.abrupt("return");
            case 9:
              s = !1;
              _this6.pipeline_ && (s = !0, _this6.pipeline_.clearListeners(), _this6.pipeline_.destroy()), _this6.pipeline_ = new Ae(_this6.transformers_), _this6.pipeline_.on("warn", i => {
                _this6.emit("warn", i);
              }), _this6.pipeline_.on("error", i => {
                _this6.emit("error", i);
              }), _this6.pipeline_.on("pipelineInfo", i => {
                s && (i === "pipeline_started" ? i = O.pipeline_restarted : i === "pipeline_started_with_error" && (i = O.pipeline_restarted_with_error)), _this6.emit("pipelineInfo", i);
              }), _this6.trackExpectedRate_ != -1 && _this6.pipeline_.setTrackExpectedRate(_this6.trackExpectedRate_), _this6.pipeline_.start(_this6.readable_, _this6.writable_).then(() => {
                e();
              }).catch(i => {
                r(i);
              });
            case 11:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      }));
      return function (_x23, _x24) {
        return _ref11.apply(this, arguments);
      };
    }());
  }
  /**
   * Sets an array of transfromer instances that will be hold and ran by the media processor instance.
   * See example [here](/docs/intro#main-code)
   *
   * @param transformers An array of transformer instances.
   *
   * @returns
   */;
  _proto6.setTransformers = function setTransformers(e) {
    return this.report({
      variation: "Update",
      message: l.updates.transformer_new
    }), this.transformers_ = e, this.readable_ && this.writable_ ? this.transformInternal() : Promise.resolve();
  }
  /**
   * Stops running the tranformation logic performed by the media processor instance.
   * @returns
   */;
  _proto6.destroy = function destroy() {
    var _this7 = this;
    return new Promise( /*#__PURE__*/function () {
      var _ref12 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee20(e) {
        return _regenerator.default.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _this7.pipeline_ && _this7.pipeline_.destroy(), _this7.report({
                variation: "Delete"
              }), e();
            case 1:
            case "end":
              return _context20.stop();
          }
        }, _callee20);
      }));
      return function (_x25) {
        return _ref12.apply(this, arguments);
      };
    }());
  };
  _proto6.report = function report(e) {
    this.reporter_.send(Object.assign({
      version: E,
      action: "MediaProcessor"
    }, e));
  };
  return Ce;
}(v);
exports.MediaProcessor = Ce;
let Me = /*#__PURE__*/function () {
  function Me() {
    this.processor_ = null, this.generator_ = null;
  }
  var _proto7 = Me.prototype;
  _proto7.init = function init(e) {
    return new Promise((r, s) => {
      try {
        this.processor_ = new MediaStreamTrackProcessor(e);
      } catch (i) {
        console.log(`[InsertableStreamHelper] MediaStreamTrackProcessor failed: ${i}`), s(i);
      }
      try {
        e.kind === "audio" ? this.generator_ = new MediaStreamTrackGenerator({
          kind: "audio"
        }) : e.kind === "video" ? this.generator_ = new MediaStreamTrackGenerator({
          kind: "video"
        }) : s("kind not supported");
      } catch (i) {
        console.log(`[InsertableStreamHelper] MediaStreamTrackGenerator failed: ${i}`), s(i);
      }
      r();
    });
  };
  _proto7.getReadable = function getReadable() {
    return this.processor_.readable;
  };
  _proto7.getWriteable = function getWriteable() {
    return this.generator_.writable;
  };
  _proto7.getProccesorTrack = function getProccesorTrack() {
    return this.generator_;
  };
  return Me;
}();
let Oe = /*#__PURE__*/function () {
  /**
   * - When running insertable streams on the main `MediaProcessorInterface` should be instance of `MediaProcessor` class.
   * - When running insertable streams on WebWorker `MediaProcessorInterface` should be instance of bridge calss created by the user. Example can be found [here](/docs/intro.md#using-the-transformer-on-webworker)
   * @param vonageMediaProcessor - MediaProcessorInterface.
   */
  function Oe(e) {
    this.insertableStreamHelper_ = new Me(), this.mediaProcessor_ = e;
  }
  /**
   * @private
   * Sets the media stream track instance to be processed.
   *
   * @param track MediaStreamTrack (audio or video) to be processed.
   *
   * @returns New track to be used.
   */
  var _proto8 = Oe.prototype;
  _proto8.setTrack = function setTrack(e) {
    return new Promise((r, s) => {
      this.insertableStreamHelper_.init(e).then(() => {
        this.mediaProcessor_.transform(this.insertableStreamHelper_.getReadable(), this.insertableStreamHelper_.getWriteable()).then(() => {
          r(this.insertableStreamHelper_.getProccesorTrack());
        }).catch(i => {
          s(i);
        });
      }).catch(i => {
        s(i);
      });
    });
  }
  /**
   * @private
   * Stops the media processing being performed.
   */;
  _proto8.destroy = function destroy() {
    return new Promise((e, r) => {
      this.mediaProcessor_ ? this.mediaProcessor_.destroy().then(() => {
        e();
      }).catch(s => {
        r(s);
      }) : r("no processor");
    });
  };
  return Oe;
}();
exports.MediaProcessorConnector = Oe;